/* eslint import/no-cycle: [1,{ maxDepth: 1 }] */
import { createAction } from "redux-actions";

import { handleSoloFileUpload } from "util/solo";
import { isRsk, isRBR, getRBRFilename } from "util/rbr";
import uploadPropsSelector from "./selectors";
import * as types from "./constants";
// eslint-disable-next-line import/no-cycle
import { soloFilesToAnnotateInvalidate } from "../annotate/actions";

/* eslint-disable max-len */
export const soloUploadFilesInvalidate = createAction(
  types.SOLO_UPLOAD_FILES_INVALIDATE
);
export const soloUploadFilesFetchRequest = createAction(
  types.SOLO_UPLOAD_FILES_FETCH_REQUEST
);
export const soloUploadFilesFetchError = createAction(
  types.SOLO_UPLOAD_FILES_FETCH_ERROR
);
export const soloUploadFilesFetchSuccess = createAction(
  types.SOLO_UPLOAD_FILES_FETCH_SUCCESS,
  x => x,
  () => ({ receivedAt: Date.now() })
);
export const soloUploadFileRequest = createAction(
  types.SOLO_UPLOAD_FILE_REQUEST
);
export const soloUploadFileSuccess = createAction(
  types.SOLO_UPLOAD_FILE_SUCCESS
);
export const soloUploadFileError = createAction(
  types.SOLO_UPLOAD_FILE_ERROR,
  x => x,
  (x, m) => m
);
/* eslint-enable max-len */

// UPLOAD FILES ASYNC ACTION
export const soloUploadFiles = files => (dispatch, getState) => {
  const { workarea, organization } = uploadPropsSelector(getState());

  files.forEach(file => {
    if (isRBR(file) || isRsk(file)) {
      const { filename: name, ext } = getRBRFilename(file);
      dispatch(soloUploadFileRequest({ workarea, organization, name }));
      handleSoloFileUpload(file, workarea, organization, ext)
        .then(json => {
          // eslint-disable-next-line no-console, no-unused-expressions
          window.console && console.log && console.log(json);
        })
        .then(() => dispatch(soloUploadFileSuccess({ name })))
        .then(() => dispatch(soloFilesToAnnotateInvalidate()))
        .catch(err => dispatch(soloUploadFileError(err, { name })));
    } else {
      dispatch(
        soloUploadFileRequest({ name: file.name, workarea, organization })
      );
      const err = new Error("Filename inconsistent with Solo files.");
      dispatch(soloUploadFileError(err, { name: file.name }));
    }
  });
};
